import React, { useEffect } from "react";
import { AiFillStar } from "react-icons/ai";
import {
  FaBook,
  FaArrowRight,
  FaLock,
  FaGraduationCap,
  FaBriefcase,
  FaUserTie,
  FaLightbulb,
} from "react-icons/fa";
import { NavLink, useLocation } from "react-router-dom";
import { courses } from "../components/assets/data/dummydata";

/* 🔥 IMPORTA TUS IMÁGENES */
import aviacionImg from "../components/assets/images/carreras/chef.jpg";
import bartenderImg from "../components/assets/images/carreras/bartender.jpg";
import chefImg from "../components/assets/images/carreras/aviacion.jpg";
import hoteleriaImg from "../components/assets/images/carreras/hosteleria.jpg";

/* ===============================
   IDENTIDAD VISUAL CEVATUR
================================= */
const COLORS = {
  red: "#D71920",
  blue: "#004AAD",
  yellow: "#F4C400",
  dark: "#0F172A",
  text: "#475569",
};

/* 🔥 ASIGNAR IMÁGENES */
const customImages = [
  aviacionImg,
  bartenderImg,
  chefImg,
];

export const Courses = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);

      if (element) {
        const top =
          element.getBoundingClientRect().top +
          window.scrollY -
          100;

        window.scrollTo({
          top,
          behavior: "smooth",
        });
      }
    }
  }, [location]);

  const handleTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <section
      id="careers"
      className="py-12"
      style={{
        background:
          "linear-gradient(180deg,#ffffff 0%,#f8fafc 45%,#eef4ff 100%)",
      }}
    >
      <div className="w-11/12 xl:w-4/5 mx-auto">
        {/* HEADER */}
        <div className="text-center max-w-5xl mx-auto mb-16">
          <span
            className="uppercase tracking-[5px] text-sm font-semibold"
            style={{ color: COLORS.blue }}
          >
            Oferta Académica
          </span>

          <h1
            className="text-6xl lg:text-5xl md:text-4xl font-bold mt-4"
            style={{ color: COLORS.red }}
          >
            Carreras y Especialidades
          </h1>

          <div
            className="w-28 h-1 mx-auto my-6 rounded-full"
            style={{ backgroundColor: COLORS.yellow }}
          ></div>

          <p
            className="text-lg max-w-4xl mx-auto"
            style={{ color: COLORS.text }}
          >
            Programas profesionales orientados al éxito laboral,
            liderazgo e innovación.
          </p>
        </div>

        {/* GRID */}
        <div className="grid grid-cols-3 gap-8 xl:grid-cols-2 md:grid-cols-1">

          {courses.map((item, index) => (
            <div
              key={index}
              className="group bg-white rounded-[28px] overflow-hidden border border-gray-100 shadow-md hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 flex flex-col"
            >
              {/* IMAGEN */}
              <NavLink to={item.url} onClick={handleTop}>
                <div className="relative h-72 overflow-hidden cursor-pointer">

                  {/* 🔥 TU IMAGEN PERSONALIZADA */}
                  <img
                    src={customImages[index] || item.cover}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition duration-700"
                  />

                  {/* OVERLAY */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>

                  {/* TAGS */}
                  <div className="absolute top-5 left-5 flex gap-2 flex-wrap">
                    <span
                      className="text-xs px-3 py-1 rounded-full text-white font-semibold"
                      style={{ backgroundColor: COLORS.blue }}
                    >
                      {item.span1}
                    </span>

                    <span
                      className="text-xs px-3 py-1 rounded-full text-white font-semibold"
                      style={{ backgroundColor: COLORS.red }}
                    >
                      {item.span2}
                    </span>
                  </div>
                </div>
              </NavLink>

              {/* CONTENT */}
              <div className="p-7 flex flex-col flex-1">

                {/* TOP */}
                <div className="flex justify-between items-center mb-4">
                  <div className="flex items-center text-sm text-gray-600">
                    <FaBook style={{ color: COLORS.blue }} />
                    <span className="ml-2">{item.module}</span>
                  </div>

                  <div className="flex items-center text-sm text-gray-600">
                    <AiFillStar style={{ color: COLORS.yellow }} />
                    <span className="ml-2">
                      {item.ranking} ({item.people})
                    </span>
                  </div>
                </div>

                {/* TITLE */}
                <NavLink to={item.url} onClick={handleTop}>
                  <h3 className="text-2xl font-bold text-slate-800 min-h-[90px] leading-snug hover:text-[#004AAD] transition">
                    {item.title}
                  </h3>
                </NavLink>

                {/* DESC */}
                <p className="text-sm text-slate-600 mt-4 min-h-[84px] leading-relaxed">
                  {item.text}
                </p>

                {/* BENEFICIOS */}
                <div className="grid grid-cols-2 gap-3 mt-6">
                  <MiniBenefit
                    icon={<FaGraduationCap />}
                    text="Educación Superior"
                  />

                  <MiniBenefit
                    icon={<FaBriefcase />}
                    text="Alta Empleabilidad"
                  />

                  <MiniBenefit
                    icon={<FaUserTie />}
                    text="Perfil Profesional"
                  />

                  <MiniBenefit
                    icon={<FaLightbulb />}
                    text="Aprendizaje Integral"
                  />
                </div>

                {/* FOOTER */}
                <div className="border-t mt-6 pt-5 flex justify-between items-center mt-auto">
                  <span className="text-sm text-slate-500">
                    Información Académica
                  </span>

                  <NavLink
                    to={item.url}
                    onClick={handleTop}
                    className="inline-flex items-center gap-2 text-sm font-semibold"
                    style={{ color: COLORS.blue }}
                  >
                    Ver Detalles
                    <FaArrowRight />
                  </NavLink>
                </div>
              </div>
            </div>
          ))}

          {/* HOSTELERÍA */}
          <div className="group bg-white rounded-[28px] overflow-hidden border border-gray-200 shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-2 flex flex-col">

            {/* IMAGEN */}
            <div className="relative h-72 overflow-hidden">

              <img
                src={hoteleriaImg}
                alt="Hostelería"
                className="w-full h-full object-cover"
              />

              <div className="absolute inset-0 bg-black/60"></div>

              <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4">

                <div className="w-20 h-20 rounded-full bg-white/15 backdrop-blur-md flex items-center justify-center text-3xl mb-4 border border-white/20">
                  <FaLock />
                </div>

                <h3 className="text-3xl font-bold">
                  Próximamente
                </h3>

                <p className="text-sm mt-2 opacity-90">
                  Nueva carrera disponible pronto
                </p>
              </div>
            </div>

            {/* CONTENT */}
            <div className="p-7 flex flex-col flex-1">

              {/* TOP */}
              <div className="flex justify-between items-center mb-4">
                <div className="flex items-center text-sm text-gray-600">
                  <FaBook style={{ color: COLORS.blue }} />
                  <span className="ml-2">Próxima Apertura</span>
                </div>

                <div className="flex items-center text-sm text-gray-600">
                  <AiFillStar style={{ color: COLORS.yellow }} />
                  <span className="ml-2">5.0 (Nuevo)</span>
                </div>
              </div>

              {/* TITLE */}
              <h3 className="text-2xl font-bold text-slate-800 min-h-[90px] leading-snug">
                Hostelería y Gestión Hotelera
              </h3>

              {/* DESC */}
              <p className="text-sm text-slate-600 mt-4 min-h-[84px] leading-relaxed">
                Formación especializada en hotelería,
                operaciones, administración y servicio
                premium orientado al turismo moderno.
              </p>

              {/* BENEFICIOS */}
              <div className="grid grid-cols-2 gap-3 mt-6">
                <MiniBenefit
                  icon={<FaGraduationCap />}
                  text="Educación Superior"
                />

                <MiniBenefit
                  icon={<FaBriefcase />}
                  text="Alta Empleabilidad"
                />

                <MiniBenefit
                  icon={<FaUserTie />}
                  text="Perfil Profesional"
                />

                <MiniBenefit
                  icon={<FaLightbulb />}
                  text="Aprendizaje Integral"
                />
              </div>

              {/* FOOTER */}
              <div className="border-t mt-6 pt-5 flex justify-between items-center mt-auto">
                <span className="text-sm text-slate-500">
                  Lanzamiento Próximo
                </span>

                <span className="text-sm text-gray-400 font-semibold flex items-center gap-2">
                  <FaLock />
                  Bloqueado
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

/* MINI BENEFIT */
const MiniBenefit = ({ icon, text }) => {
  return (
    <div className="bg-slate-50 border border-slate-100 rounded-xl p-3 flex items-center gap-2">

      <div
        className="text-sm"
        style={{ color: COLORS.blue }}
      >
        {icon}
      </div>

      <span className="text-[11px] font-medium text-slate-700 leading-tight">
        {text}
      </span>
    </div>
  );
};